export const CSV_DATA_FILTER_TYPE = {
  SEARCH: "search",
  DYNAMIC_AUTOCOMPLETE: "dynamic_autocomplete",
  VALUES: "values",
  RANGE: "range",
  RADIO: "radio",
  RULESET: "ruleset"
};
